import { render, staticRenderFns } from "./announceDetail.vue?vue&type=template&id=49ffa6e2&scoped=true&"
import script from "./announceDetail.vue?vue&type=script&lang=js&"
export * from "./announceDetail.vue?vue&type=script&lang=js&"
import style0 from "./announceDetail.vue?vue&type=style&index=0&id=49ffa6e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ffa6e2",
  null
  
)

export default component.exports